

function SignUp() {
  return ( 
    <div>
      <div>
       <input type="text" />
       <input type="text" />
       <button>SignUp</button>
      </div>
    </div>
   );
}

export default SignUp;